import { FlyerMasonryInfinite } from '@/components/FlyerboardPagination/FlyerMasonryInfinite';

import { FlyerCard } from '@/components';

import { FlyerCardThumbnail } from '@/graphql/types';

type Props = {
  trackId: string;
  flyers: FlyerCardThumbnail[];
  total: number;
  nextPage: () => void;
  audienceId?: string;
  districtId?: string | null;
  trackingEventFrom: string;
  showTags?: boolean;
  className?: string;
  isEmbedded?: boolean;
};

export const FlyerList: React.FC<Props> = ({
  trackId,
  flyers,
  total,
  nextPage,
  audienceId,
  districtId,
  trackingEventFrom,
  className,
  showTags = false,
  isEmbedded = false,
}) => (
  <FlyerMasonryInfinite
    style={{ marginBottom: '24px', overflow: 'hidden' }}
    items={flyers}
    total={total}
    nextPage={nextPage}
    className={className}
    renderItem={item => (
      <FlyerCard
        key={item.flyerId}
        id={item.flyerId}
        title={item.title}
        thumbnail={item.frontImageUrl}
        isFavorite={item.isFavorite}
        trackId={trackId}
        isRead={item.isRead}
        audienceId={audienceId}
        districtId={districtId}
        trackingEventFrom={trackingEventFrom}
        titleTranslations={item.titleTranslations}
        isCommunityFree={item.isCommunityFree}
        isExpandedCommunity={item.isExpandedCommunity}
        flyerType={item.type}
        showTag={showTags}
        ctas={item.ctas}
        pages={item.pages}
        isEmbedded={isEmbedded}
        distributionsReleased={item.distributionsReleased}
      />
    )}
  />
);
